import { Container, FederatedPointerEvent, Text, TextStyle } from "pixi.js";
import { ButtonWithScaleAnimationAndText } from "../../../common/components/ButtonWithScaleAnimationAndText";
import { CommonResourcesPackage } from "../../../common/resources/CommonResourcesPackage";
import { GameFont } from "../../../common/GameFont";
import { Event } from "event-system";

export class MonBuyContainer extends Container {
    private static readonly BUY_TEXT = "BUY";

    private readonly commonResources: CommonResourcesPackage;

    private buyButton: ButtonWithScaleAnimationAndText;

    public get buyButtonClick(): Event<ButtonWithScaleAnimationAndText, FederatedPointerEvent> {
        return this.buyButton.onUp;
    }

    public constructor(
        commonResources: CommonResourcesPackage,
    ) {
        super();
        this.commonResources = commonResources;
        this.build();
        this.layout();
    }

    private build(): void {
        this.buyButton = new ButtonWithScaleAnimationAndText(this.commonResources.assets_common_ui_button_green_png, MonBuyContainer.BUY_TEXT, new ButtonTextStyle());
        this.buyButton.scale.set(0.84);

        this.addChild(
            this.buyButton,
        );
    }

    private layout(): void {
        this.buyButton.position.set(this.width * 0.5 - this.buyButton.width * 0.5, 0);
    }
}

class ButtonTextStyle extends TextStyle {
    public constructor() {
        super({
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 60,
            fill: 'FFFFFF',
            dropShadow: true,
            dropShadowAlpha: 0.4,
            dropShadowAngle: 0.78,
            dropShadowBlur: 9,
            dropShadowColor: '0D0606',
            dropShadowDistance: 5.3
        });
    }
}
